<app-loader
  *ngIf="showInboundProductTransition"
  title="Opening My Hivve"
  message="Connecting you securely."
></app-loader>
<main
  [attr.inert]="showInboundProductTransition ? '' : null"
  [attr.aria-hidden]="showInboundProductTransition ? 'true' : null"
>
  <router-outlet></router-outlet>
</main>
<app-svg-sprite-def class="d-none"></app-svg-sprite-def>
